export default function version() {
	console.log("Madnes version: 22.0.12");
	console.log("JB version: 1.2.0");
	console.log("Game version: v26.41.01");
}